import { render, staticRenderFns } from "./RoleMgr.vue?vue&type=template&id=e411e4d2&"
import script from "./RoleMgr.vue?vue&type=script&lang=js&"
export * from "./RoleMgr.vue?vue&type=script&lang=js&"
import style0 from "./RoleMgr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports